import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import humanize from "underscore.string/humanize";
import { OFFER_STATUSES } from "./../../config/constants";
import {
  ButtonOutline,
} from './../buttons';

export default function StatusIndicator({preoffer, theme='light'}){
  const { status } = preoffer;

  let classNames = 'status-circle me-2';
  if(status === OFFER_STATUSES.LIVE) {
    classNames += ' bg-success';
  }
  else if(status === OFFER_STATUSES.CLOSED) {
    classNames += ' bg-danger';
  }
  else {
    classNames +=  ' bg-white';
  }

  return (
    <>
      <span className="btn-status text-capitalize me-3 fs-10">
        <span className={classNames} />
        {humanize(status)}
      </span>
      <ButtonOutline
        theme={theme}
        icon={<FaExternalLinkAlt className="ms-2" />}
        text="Preview"
        onClick={() => window.open(`${process.env.REACT_APP_INVESTOR_APP_URL}/prelaunch/${preoffer.slug}`, "_blank") }
      />
    </>
  )
}
